/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout'

const componentsRouter = {
  path: '/components',
  component: Layout,
  redirect: 'noRedirect',
  name: 'ComponentDemo',
  meta: {
    title: 'VP & SW Debug',
    icon: 'component'
  },
  children: [
    {
      path: 'virtualplatform',
      component: () => import('@/views/components-demo/drag-select'),
      name: 'virtualplatform',
      meta: { title: 'Virtual Platform' }
    },
    {
      path: 'swdebug',
      component: () => import('@/views/components-demo/dnd-list'),
      name: 'swdebug',
      meta: { title: 'SW Debug' }
    },
    // {
    //   path: 'drag-kanban',
    //   component: () => import('@/views/components-demo/drag-kanban'),
    //   name: 'DragKanbanDemo',
    //   meta: { title: 'dragKanban' }
    // }
  ]
}

export default componentsRouter
